export const GET_ORGANIZATION_SEARCH_START =
  'GET_ORGANIZATION_SEARCH_START';
export const GET_ORGANIZATION_SEARCH_SUCCESS =
  'GET_ORGANIZATION_SEARCH_SUCCESS';
export const GET_ORGANIZATION_SEARCH_ERROR =
  'GET_ORGANIZATION_SEARCH_ERROR';
